import {
  Icon,
  Layout,
  Spacer,
  SvgClock,
  SvgEye,
  Text,
  Tooltip,
} from '@loomhq/lens';
import pluralize from 'pluralize';
import React from 'react';
import { useSelector } from 'react-redux';

import { LOOM_URI } from 'constants/routes';
import { getCloudfrontURI } from 'utilities/avatar';
import { secondsToHumanReadableString } from 'utilities/time';
import { goToNewTab } from 'utilities/url';

import { selectVideo, selectVideoDuration } from 'selectors/videoPlayer';

import { limit } from '../formatting';

import { EmbedContext } from 'components/embed-video';
import UserAvatar from 'components/user-avatar';

import styles from './styles.module.less';

const limitTo20Characters = limit(20);

const EmbedTitleAuthor = () => {
  const video = useSelector(selectVideo);
  const ownerName = video?.owner_full_name;
  const avatar = video?.owner_avatar?.thumb;
  const duration = Math.floor(useSelector(selectVideoDuration));

  const showViews = Boolean(video.views);
  const viewCount = video.views?.total;

  const shareUrl = `${LOOM_URI}/share/${video.id}`;

  const titleClick = () => {
    goToNewTab(shareUrl);
  };

  return (
    <EmbedContext.Consumer>
      {({ hideOwner, hideTitle }) => (
        <div>
          <Layout alignment="center" className={styles.embedTitleAuthor}>
            {!hideOwner && (
              <>
                <div
                  className={styles.avatar}
                  data-testid="embed-topbar-avatar"
                >
                  <Tooltip content={ownerName} placement="bottomCenter">
                    <UserAvatar
                      avatarSize={3}
                      avatarSrc={avatar && getCloudfrontURI(avatar)}
                      name="author"
                    />
                  </Tooltip>
                </div>
                <Spacer right="12px"></Spacer>
              </>
            )}
            {!hideTitle && (
              <Text
                onClick={titleClick}
                style={{ cursor: 'pointer' }}
                hasEllipsis
                size="xlarge"
                fontWeight="medium"
              >
                {video.name}
              </Text>
            )}
            {hideTitle && !hideOwner && (
              <Text hasEllipsis size="xlarge" fontWeight="medium">
                {limitTo20Characters(ownerName)}
              </Text>
            )}
          </Layout>
          <Spacer top="small" />
          <Layout
            gap="small"
            alignment="center"
            className={styles.timeViewsRow}
          >
            <Icon
              data-testid="embed-topbar-duration-icon"
              color="grey1"
              icon={<SvgClock />}
            />
            <Text>{secondsToHumanReadableString(duration)}</Text>
            {showViews && (
              <>
                <Icon
                  data-testid="embed-topbar-views-icon"
                  color="grey1"
                  icon={<SvgEye />}
                />
                <Text>
                  {viewCount} {pluralize('view', viewCount)}
                </Text>
              </>
            )}
          </Layout>
        </div>
      )}
    </EmbedContext.Consumer>
  );
};

export default EmbedTitleAuthor;
